// extracted by mini-css-extract-plugin
export default {"colourInterior":"Xk4JxCx4UU"};